import script from "./appointment-confirmation-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./appointment-confirmation-modal.vue?vue&type=script&setup=true&lang=ts"

import "./appointment-confirmation-modal.vue?vue&type=style&index=0&id=3da64a7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da64a7e"]])

export default __exports__